import './assets/css/app.css'
import {createApp} from 'vue'
import App from './App.vue'
import "bootstrap";
import "admin-lte"
import auth from "@/components/auth/auth";
import routes from "@/core/routes.js";
import Multiselect from '@vueform/multiselect'
import moment from "moment";
import "@webzlodimir/vue-bottom-sheet/dist/style.css";

const app = createApp(App);
app.config.globalProperties.$moment = moment;
app.component('v-select', Multiselect)
app.use(auth)
app.use(routes)

app.mount('#app')
